import { render, staticRenderFns } from "./placeOrder.vue?vue&type=template&id=4f49ffd4&scoped=true"
import script from "./placeOrder.vue?vue&type=script&lang=js"
export * from "./placeOrder.vue?vue&type=script&lang=js"
import style0 from "./placeOrder.vue?vue&type=style&index=0&id=4f49ffd4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f49ffd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f49ffd4')) {
      api.createRecord('4f49ffd4', component.options)
    } else {
      api.reload('4f49ffd4', component.options)
    }
    module.hot.accept("./placeOrder.vue?vue&type=template&id=4f49ffd4&scoped=true", function () {
      api.rerender('4f49ffd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/mdInfo/components/placeOrder.vue"
export default component.exports